import { formatPhoneNumber } from "Services/CommunicationService";

import type { RVTask, ConferenceParticipant } from "@regal-voice/shared-types";
import type { ParticipantInfo } from "Services/state/conferences";

export type UseCallTitleOptions = {
    participant?: ParticipantInfo | ConferenceParticipant<"contact">;
    task?: RVTask;
};

export const useCallTitle = ({ participant, task }: UseCallTitleOptions): string => {
    if (!participant || !task) {
        return "";
    }

    // but we will clean up the rolloutStateSse flag and we can remove this
    const displayName =
        ("name" in participant ? participant.name : null) ||
        ("label" in participant ? formatPhoneNumber(participant.label) : null) ||
        formatPhoneNumber(participant.phoneNumber);
    const taskTitle: string = task.attributes?.title || "";
    return taskTitle.match(/incoming/i) ? `${taskTitle} from ${displayName}` : `${taskTitle} to ${displayName}`;
};
